// Shared types and constants for the ConsoleDashboard module.
// Keep all ConsoleDashboard-specific interfaces and constants here
// so they can be imported by section components without circular dependencies.

import { ConsoleDashboardDescriptionSections, ConsoleDashboardModelRow, ConsoleDashboardSourceTable } from '../../../types';

export interface ModelRowState extends Omit<ConsoleDashboardModelRow, 'source_table_ids'> {
  _uid: string;
  // CHANGED: source_tables replaces source_table_ids
  source_tables: ConsoleDashboardSourceTable[];
}

export interface ColumnsDerivedEntry {
  table_name: string;
  columns: string[];
}

export const DEFAULT_DESCRIPTION_SECTIONS: ConsoleDashboardDescriptionSections = {
  dashboard_purpose: '',
  cannot_answer: '',
  filters_applicable: '',
  what_it_answers: '',
  business_rules_logic: '',
};